import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import { motion, useReducedMotion } from "framer-motion";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';
import Slider from "react-slick";
import { getPageContents } from "../../actions/admin/cmspage";
import LazyImage from "../../components/common/LazyImage";
import ByTheHourForm from "../../components/layout-new-theme/form-card/ByTheHourForm";
import SpecifiedDestinationForm from "../../components/layout-new-theme/form-card/SpecifiedDestinationForm";
import FrontLayout from "../../components/layout-new-theme/FrontLayout";
import {
  AirportPinIcon,
  DisclaimerIcon,
  TrainPinIcon,
} from "../../components/icons";
import {
  HoverCard,
  Reveal,
  Stagger,
  StaggerItem,
  SwapPanel,
  drawLine,
  imageZoom,
  pressable,
  transitions,
} from "../../components/motion";
import { cn } from "../../utils/classnames";
import { createTypographyHelper } from "../../utils/typography";
import DisclaimerModal from "./_components/DisclaimerModal";
import VehicleCard from "./fleet/_components/VehicleCard";
import GranLuxeHeroVehicle, {
  GRANLUXE_CABIN_IMAGE,
  GRANLUXE_CABIN_SRCSET,
} from "./_components/GranLuxeHeroVehicle";
import { WELL_CABIN_BANNER } from "../../utils/optimizedImages";

const newBanner = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-index/Banner_NEW.jpg";
const HanedaAirportImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-index/haneda-airport.png";
const NaritaAirportImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-index/narita-airport.png";
const TokyoStation = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-index/tokyo-station-new.png";
const ShinagawaStation = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-index/shinagawa-station-new.png";
const PanasonicAutomotiveImageBackgroundBlack = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/panasonic-automotive-bg-black.png";

const Index = () => {
  const dispatch = useDispatch();
  const page_name = "cms-index";
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const cmspage_state = useSelector((state) => state.cmspage);
  const { cmspage } = cmspage_state;
  const lang = i18n.language?.toUpperCase();
  const getTypographyClass = createTypographyHelper(i18n.language);
  const isJapanese = i18n.language === "jp";
  const shouldReduceMotion = useReducedMotion();

  useEffect(() => {
    dispatch(getPageContents(page_name));
  }, [dispatch]);
  const [tabName, setTabName] = useState("byTheHour");
  // 1 = the new tab sits to the right of the old one, -1 = to the left. Drives
  // which way the two booking forms slide past each other.
  const [tabDirection, setTabDirection] = useState(1);
  const [cutomerChangedDropOffTimeOnly, setcutomerChangedDropOffTimeOnly] =
    useState("");
  const availabilityValueReset = () => { };
  const [formdatavalidation, setFormdatavalidation] = useState({
    pickuplocation: true,
    dropofflocations: true,
    traveldate: true,
    pickuptime: true,
    pax: true,
    flightNumber: true,
    duration: true,
    isAirportTransfer: null,
    isStationTransfer: null,
  });
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);

  const getLinkDetail = (name) => {
    switch (name) {
      case "Toyota Alphard":
        return "./fleet-types?type=ToyotaAlphard";
        break;
      case "Toyota GranAce":
        return "./fleet-types?type=ToyotaGranAce";
        break;
      case "Toyota HiAce Grand Cabin":
        return "./fleet-types?type=ToyotaHiAceGrandCabin";
        break;
      case "Toyota HiAce Luxury Cabin":
        return "./fleet-types?type=ToyotaHiAceLuxuryCabin";
        break;
      case "Mercedes Benz V-Class":
        return "-";
        break;
      case "Mercedes Benz S-Class":
        return "-";
        break;
      case "Toyota Alphard WELL Cabin Luxe":
        return "-";
        break;
      case "WELL Cabin Granluxe":
        return "./fleet-types?type=WELLCabinGranLuxe";
      case "WELL Cabin GranLuxe":
        return "./fleet-types?type=WELLCabinGranLuxe";
        break;

      default:
        break;
    }
  };

  const settingsSlide = {
    dots: true,
    arrows: false,
    // infinite: false,
    speed: 500,
    slidesToShow: 1.25,
    slidesToScroll: 1,
    // centerMode: true,
    customPaging: (i) => (
      <div className="tw:h-[7px] tw:w-[7px] tw:rounded-full tw:bg-[#D9D9D9]"></div>
    ),
    appendDots: (dots) => (
      <div className="">
        <ul className="tw:flex tw:!pl-1 tw:!mt-[28px] tw:!mb-0 tw:gap-[14px]">
          {dots}
        </ul>
      </div>
    ),

    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  useEffect(() => {
    setFormdatavalidation({
      pickuplocation: true,
      dropofflocations: true,
      traveldate: true,
      pickuptime: true,
      pax: true,
      flightNumber: true,
      duration: true,
      isAirportTransfer: null,
      isStationTransfer: null,
    });
  }, [tabName]);

  /**
   * * Set the selected tab (Airport Transfer, Single Destination, Multiple Destinations, By The Hour)
   ** Check tabName parameter value
   */
  const getTab = () => {
    if (tabName === "byTheHour")
      return (
        <ByTheHourForm
          cutomerChangedDropOffTimeOnly={cutomerChangedDropOffTimeOnly}
          setcutomerChangedDropOffTimeOnly={(val) => {
            setcutomerChangedDropOffTimeOnly(val);
          }}
          availabilityValueReset={availabilityValueReset}
          formValidationData={formdatavalidation}
        />
      );
    if (tabName === "specifiedDestination")
      return (
        <SpecifiedDestinationForm
          cutomerChangedDropOffTimeOnly={cutomerChangedDropOffTimeOnly}
          setcutomerChangedDropOffTimeOnly={(val) => {
            setcutomerChangedDropOffTimeOnly(val);
          }}
          availabilityValueReset={availabilityValueReset}
          formValidationData={formdatavalidation}
        />
      );
  };

  const bookTabs = [
    { name: "byTheHour", label: t("ByTheHour.Destinations.Mobile") },
    { name: "specifiedDestination", label: t("Specified.Destinations") },
  ];

  const selectTab = (name) => {
    if (name === tabName) return;
    const from = bookTabs.findIndex((tab) => tab.name === tabName);
    const to = bookTabs.findIndex((tab) => tab.name === name);
    setTabDirection(to > from ? 1 : -1);
    setTabName(name);
  };

  // The hero vehicle and its hotspot label both deep-link to the same fleet page.
  const wellCabinDetailPath = `/${i18n.language}/fleet-types?type=WELLCabinGranLuxe`;
  const wellCabinTitle = t("FleetTypePage.WELLCabinGranLuxe.Title");
  const wellCabinViewDetails = t(
    "FleetTypePage.WELLCabinGranLuxe.HeroBanner.ViewDetails"
  );

  const isAlphardOrGranace = (name) => {
    return name === "Toyota Alphard" || name === "Toyota GranAce";
  };

  return (
    <FrontLayout>
      <div className="tw:relative tw:max-w-[1920px] tw:mx-auto">
        <div
          className={`tw:hidden tw:md:block tw:max-w-[1920px] tw:m-auto tw:relative`}
        >
          {/* Aspect ratio is pinned to the retired banner's 1440x666 so the
              headline and booking form keep their percentage offsets. */}
          <GranLuxeHeroVehicle
            src={GRANLUXE_CABIN_IMAGE}
            srcSet={GRANLUXE_CABIN_SRCSET}
            sizes="(min-width: 1920px) 960px, 50vw"
            alt={wellCabinTitle}
            to={wellCabinDetailPath}
            cta={wellCabinViewDetails}
            parallax
            delay={0.1}
            className="tw:w-full tw:aspect-[1440/666]"
            vehicleClassName="tw:left-[2%] tw:top-[10%] tw:w-[50%]"
          />
        </div>
        <div className="tw:hidden tw:md:block tw:md:absolute tw:z-10 tw:bottom-[15%] tw:w-[40%] tw:left-[76px] tw:cursor-pointer tw:max-w-[1920px]">
          <Reveal
            onMount
            y={28}
            duration={0.8}
            delay={0.15}
            className="tw:font-libre-caslon-display tw:text-white tw:text-[30px] tw:md:text-[45px] tw:leading-[40px] tw:md:leading-[58px]"
            dangerouslySetInnerHTML={{
              __html:
                lang === "EN"
                  ? cmspage?.page_content_en.content1
                  : cmspage?.page_content_jp.content1,
            }}
          >
          </Reveal>
        </div>
        <div
          className={`tw:w-full tw:md:absolute tw:md:z-[40] tw:top-[180px] tw:md:top-[10%] tw:md:left-[50%] tw:md:-translate-x-[50%] tw:md:px-[76px] tw:md:bg-none tw:max-w-[1920px] tw:m-auto tw:pointer-events-none`}
        >
          <div className="tw:absolute tw:md:hidden tw:w-full tw:pointer-events-auto">
            {/* Same 262px band the mobile banner used to occupy, above the form. */}
            <GranLuxeHeroVehicle
              src={GRANLUXE_CABIN_IMAGE}
              srcSet={GRANLUXE_CABIN_SRCSET}
              alt={wellCabinTitle}
              to={wellCabinDetailPath}
              enterFrom={-24}
              delay={0.05}
              className="tw:w-full tw:h-[262px]"
              vehicleClassName="tw:left-0 tw:top-[-2%] tw:w-full"
            >
              {/* Same left-hand scrim the old mobile banner had, so the
                  headline stays legible where it crosses the vehicle. */}
              <div
                aria-hidden="true"
                className="tw:pointer-events-none tw:absolute tw:inset-0 tw:bg-[linear-gradient(90deg,rgba(10,11,13,0.95)_0%,rgba(10,11,13,0.82)_30%,rgba(10,11,13,0.55)_62%,rgba(10,11,13,0)_92%)]"
              ></div>
            </GranLuxeHeroVehicle>
          </div>
          <div>
            <div className="tw:relative tw:pt-[80px] tw:md:hidden tw:z-10 tw:pointer-events-none">
              <Reveal
                onMount
                y={20}
                duration={0.7}
                delay={0.1}
                className="tw:font-libre-caslon-display tw:text-white tw:px-[30px] tw:text-[30px] tw:leading-[40px] tw:pb-7 tw:pointer-events-auto"
                dangerouslySetInnerHTML={{
                  __html:
                    (lang === "EN"
                      ? cmspage?.page_content_en.content1
                      : cmspage?.page_content_jp.content1
                    )?.replace(/<br\s*\/?>/gi, " ").replace(/\n/g, " "),
                }}
              >
              </Reveal>
            </div>
            <div id="booking-form-section" className="tw:relative tw:grid tw:grid-cols-2 tw:pb-5 tw:md:pb-0">
              <div className="tw:hidden tw:2xl:block tw:2xl:w-[644px]"></div>
              <div className="tw:col-span-2 tw:md:col-span-1 tw:md:col-end-3 tw:pointer-events-auto">
                <Reveal
                  onMount
                  y={22}
                  duration={0.7}
                  delay={0.3}
                  className="tw:md:max-w-[625px] tw:md:ml-auto"
                >
                  {/* <!-- select tab btns --> */}
                  <div className="tw:flex tw:justify-between tw:items-end tw:w-full tw:border-b-4 tw:border-b-[#333333]">
                    {bookTabs.map((tab) => {
                      const isActiveTab = tab.name === tabName;
                      return (
                        <div
                          key={tab.name}
                          className={cn(
                            "tw:relative tw:flex-1 tw:rounded-t-[5px] tw:flex tw:items-center tw:justify-center tw:text-center tw:cursor-pointer",
                            isActiveTab
                              ? cn(
                                "tw:text-white tw:h-[74px] tw:md:text-base",
                                getTypographyClass(14)
                              )
                              : cn(
                                "tw:h-[59px] tw:text-[#A7A7A7] tw:bg-[#282828]",
                                getTypographyClass(12),
                                getTypographyClass(13, "md")
                              )
                          )}
                          onClick={() => selectTab(tab.name)}
                        >
                          {/* Shared-layout pill: the active tab's background is a
                              single element that slides + resizes between tabs. */}
                          {isActiveTab && (
                            <motion.span
                              layoutId="booking-tab-highlight"
                              className="tw:absolute tw:inset-0 tw:bg-[#333333]"
                              style={{ borderRadius: "5px 5px 0 0" }}
                              transition={
                                shouldReduceMotion
                                  ? { duration: 0 }
                                  : transitions.spring
                              }
                            />
                          )}
                          <span className="tw:relative tw:z-[1]">{tab.label}</span>
                        </div>
                      );
                    })}
                  </div>
                  {/* <!-- hero form part --> */}
                  {/* The two forms cross over each other in place — the old one
                      slides out as the new one slides in, and the wrapper's
                      height eases between them so the page below doesn't jump. */}
                  <SwapPanel activeKey={tabName} direction={tabDirection}>
                    {getTab()}
                  </SwapPanel>
                </Reveal>
                {/* <!-- hero form part end --> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="tw:block tw:md:hidden">
        <div>
          <div className="tw:pt-[60px] tw:pb-[32px] tw:px-[20.5px] tw:bg-[linear-gradient(0deg,#090B0A,#090B0A),linear-gradient(90deg,rgba(7,9,8,0.75)_78.41%,rgba(7,9,8,0)_96.07%)]">
            <Stagger className="tw:flex tw:flex-col tw:items-center tw:gap-y-[14px]" stagger={0.08}>
              <StaggerItem y={14} className={cn("tw:tracking-[3px] tw:font-semibold tw:uppercase tw:text-[#A7A7A7] tw:text-[12px]")}>
                {t("FleetTypePage.WELLCabinGranLuxe.HeroBanner.Eyebrow")}
              </StaggerItem>
              <StaggerItem y={14} className={cn("tw:font-libre-caslon-display tw:md:text-[45px] tw:leading-[42px] tw:md:leading-[58px] tw:mt-[10px] tw:text-white tw:text-center tw:w-[220px]", isJapanese ? "tw:text-[22px]" : "tw:text-[26px]")}>
                {t("FleetTypePage.WELLCabinGranLuxe.Title")}
              </StaggerItem>
              <StaggerItem y={14} className={cn("tw:flex tw:items-center tw:gap-x-3 tw:mt-4", isJapanese ? "tw:flex-row" : "tw:flex-row")}>
                <span className="tw:text-[8px] tw:tracking-[3px] tw:font-semibold tw:uppercase tw:text-[#A7A7A7]">
                  {t("FleetTypePage.WELLCabinGranLuxe.CollaborationWith")}
                </span>
                <img
                  src={PanasonicAutomotiveImageBackgroundBlack}
                  alt="Panasonic Automotive"
                  className="tw:h-[15px] tw:w-auto tw:object-contain"
                />
              </StaggerItem>
            </Stagger>

          </div>
          <LazyImage
            // Right-sized copies of the 9504px original (see utils/optimizedImages).
            src={WELL_CABIN_BANNER.src}
            srcSet={WELL_CABIN_BANNER.srcSet}
            sizes={WELL_CABIN_BANNER.sizes}
            alt="WELL Cabin Luxe banner"
            wrapperClassName="tw:w-full tw:h-[300px] tw:sm:h-[510px]"
            className="tw:w-full tw:h-full tw:object-cover"
          />
          <div className="tw:py-[32px] tw:px-[20.5px] tw:bg-[linear-gradient(0deg,#090B0A,#090B0A),linear-gradient(90deg,rgba(7,9,8,0.75)_78.41%,rgba(7,9,8,0)_96.07%)]">
            <Reveal y={16} className="tw:text-[13px] tw:md:text-[13px] tw:leading-[18.5px] tw:text-[#DADADA]">
              {t("FleetTypePage.WELLCabinGranLuxe.HeroBanner.Description")}
            </Reveal>
            <Reveal y={16} delay={0.1} className="tw:mt-6">
              {/* Block, not the default inline-block: an inline button sits on
                  the text baseline, which leaves a few px of descender space
                  under it and makes the bottom padding look bigger. */}
              <motion.button
                type="button"
                onClick={() => history.push("./fleet-types?type=WELLCabinGranLuxe")}
                className="tw:block tw:w-full"
                whileTap={pressable.tap}
              >
                <div className="tw:h-[45px] tw:sm:h-[50px] tw:bg-white tw:text-[#282828] tw:font-semibold tw:text-sm tw:rounded-[5px] tw:flex tw:items-center tw:justify-center tw:gap-2 tw:hover:bg-[#F3F3F3]">
                  {t("FleetTypePage.WELLCabinGranLuxe.HeroBanner.ViewDetails")}
                  <i className="fa fa-arrow-right" aria-hidden="true"></i>
                </div>
              </motion.button>
            </Reveal>
          </div>
        </div>
      </div>


      <div className="tw:max-w-[1920px] tw:mx-auto tw:relative tw:overflow-hidden tw:hidden tw:md:block">
        <LazyImage
          // Right-sized copies of the 9504px original (see utils/optimizedImages).
          src={WELL_CABIN_BANNER.src}
          srcSet={WELL_CABIN_BANNER.srcSet}
          sizes={WELL_CABIN_BANNER.sizes}
          alt="Toyota Alphard WELL Cabin Luxe banner"
          wrapperClassName="tw:w-full tw:h-[300px] tw:sm:h-[510px]"
          className="tw:w-full tw:h-full tw:object-cover"
        />

        <div className="tw:absolute tw:inset-0 tw:md:flex tw:items-end tw:justify-end">
          {/* The tint is its own layer rather than the text panel's background,
              so it can reach further across the banner while the copy below
              keeps its original 520px column. */}
          <div
            aria-hidden="true"
            className="tw:absolute tw:inset-y-0 tw:right-0 tw:w-full tw:max-w-[560px] tw:lg:max-w-[600px] tw:bg-[linear-gradient(-90deg,rgba(7,9,8,0.75)_78.41%,rgba(7,9,8,0)_96.07%)]"
          ></div>
          {/* Positioned so it paints above the tint layer, which is absolute.
              A centred flex column, so the leftover height is split evenly above
              the eyebrow and below the button instead of all collecting under
              the button. Flex also blockifies the button, which as an inline
              element would otherwise add descender space beneath it. */}
          <Stagger className="tw:relative tw:w-full tw:max-w-[520px] tw:h-full tw:flex tw:flex-col tw:justify-center tw:text-white tw:font-hanken-grotesk tw:sm:px-[67px] tw:py-0 tw:sm:py-[71.5px]" stagger={0.08}>
            <StaggerItem y={18} className={cn("tw:tracking-[3px] tw:font-semibold tw:uppercase tw:text-[#A7A7A7] tw:text-[12px]")}>
              {t("FleetTypePage.WELLCabinGranLuxe.HeroBanner.Eyebrow")}
            </StaggerItem>

            {/* One size for both languages — the Japanese title used to drop to 34px. */}
            <StaggerItem y={18} className="tw:font-libre-caslon-display tw:text-[45px] tw:leading-[42px] tw:font-[400] tw:md:leading-[58px] tw:mt-[10px]">
              {t("FleetTypePage.WELLCabinGranLuxe.Title")}
            </StaggerItem>

            <StaggerItem y={18} className={cn("tw:!flex tw:!items-center tw:gap-x-[6px] tw:md:gap-x-[10px] tw:mt-4", isJapanese ? "tw:flex-row-reverse tw:justify-end" : "tw:flex-row tw:justify-start")}>
              <span className="tw:text-[10px] tw:tracking-[3px] tw:font-semibold tw:uppercase tw:text-[#A7A7A7]">
                {t("FleetTypePage.WELLCabinGranLuxe.CollaborationWith")}
              </span>
              <img
                src={PanasonicAutomotiveImageBackgroundBlack}
                alt="Panasonic Automotive"
                className="tw:h-[22px] tw:w-auto tw:object-contain"
              />
            </StaggerItem>

            {/* Rule wipes in from the left instead of just appearing. The rule
                owns the gap on both of its sides, so the description below it
                adds no top margin of its own. */}
            <StaggerItem
              variants={drawLine()}
              className="tw:my-6 tw:border-b tw:border-b-[#6E6E6E] tw:origin-left"
            ></StaggerItem>

            <StaggerItem y={18} className={cn("tw:text-[12px] tw:leading-5 tw:text-[#DADADA] tw:md:text-[13px]")}>
              {t("FleetTypePage.WELLCabinGranLuxe.HeroBanner.Description")}
            </StaggerItem>

            <StaggerItem
              as="button"
              y={18}
              type="button"
              onClick={() => history.push("./fleet-types?type=WELLCabinGranLuxe")}
              className="tw:w-full"
              whileHover={pressable.hover}
              whileTap={pressable.tap}
            >
              <div className="tw:mt-6 tw:h-[45px] tw:sm:h-[50px] tw:bg-white tw:text-[#282828] tw:font-semibold tw:text-sm tw:rounded-[5px] tw:flex tw:items-center tw:justify-center tw:gap-2 tw:hover:bg-[#F3F3F3]">
                {t("FleetTypePage.WELLCabinGranLuxe.HeroBanner.ViewDetails")}
                <i className="fa fa-arrow-right" aria-hidden="true"></i>
              </div>
            </StaggerItem>
          </Stagger>
        </div>
      </div>

      {/* <!-- section 1 --> */}

      <div className="tw:max-w-[1920px] tw:m-auto tw:md:px-[75px] tw:bg-white tw:py-12 tw:md:py-[72px]">
        <div
          className={`${tabName === "byTheHour" ? `mt-0` : `mt-5 mt-md-0`
            } tw:px-5 tw:md:px-0`}
        >
          <div className="">
            <Reveal
              y={20}
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content2
                    : cmspage?.page_content_jp.content2,
              }}
              className="tw:text-[26px] tw:md:text-[34px] tw:font-normal tw:leading-[45px] tw:mb-0 tw:font-libre-caslon-display"
            >
              {/* {t("Index.Heading.One")} */}
            </Reveal>
          </div>
        </div>

        <div className="tw:mt-8 tw:md:mt-[34px]">
          <Reveal y={20} delay={0.08} className="tw:md:hidden tw:ml-3">
            <Slider {...settingsSlide}>
              <div className="tw:h-[330px] tw:overflow-hidden tw:relative tw:px-1">
                <div className="tw:w-[252px] tw:bg-[#272727] tw:h-full tw:rounded-[5px] tw:overflow-hidden">
                  <div className="tw:h-[224px] tw:relative">
                    <LazyImage
                      src={
                        lang === "EN"
                          ? cmspage?.page_content_en.image1
                          : cmspage?.page_content_jp.image1
                      }
                      alt="Highly-trained chauffeurs"
                      wrapperClassName="tw:h-[224px] tw:w-[252px]"
                      className="tw:h-full tw:w-full tw:object-cover"
                    />

                    <div className="tw:bg-[linear-gradient(180deg,_rgba(39,_39,_39,_0.18)_70.91%,_#272727_104.19%)] tw:h-full tw:absolute tw:w-full tw:top-0 tw:z-10"></div>
                  </div>
                  <div className="tw:px-4 tw:absolute tw:top-[146px] tw:z-20">
                    <div className="tw:border-t tw:border-t-[#dbbe78]">
                      <div className="tw:my-[15px]">
                        <div
                          className="tw:!font-libre-caslon-display tw:text-white tw:!text-lg tw:!font-normal tw:!leading-[24px]"
                          dangerouslySetInnerHTML={{
                            __html:
                              lang === "EN"
                                ? cmspage?.page_content_en.content3
                                : cmspage?.page_content_jp.content3,
                          }}
                        ></div>
                      </div>
                      <div
                        className={cn(
                          "tw:!font-hanken-grotesk tw:!font-normal tw:!text-[#DCDBDB]",
                          getTypographyClass(12, undefined, { important: true })
                        )}
                        dangerouslySetInnerHTML={{
                          __html:
                            lang === "EN"
                              ? cmspage?.page_content_en.content4
                              : cmspage?.page_content_jp.content4,
                        }}
                      >
                        {/* {t("Index.Card.One.Content")} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tw:h-[330px] tw:overflow-hidden tw:relative tw:px-1">
                <div className="tw:w-[252px] tw:bg-[#272727] tw:h-full tw:rounded-[5px] tw:overflow-hidden">
                  <div className="tw:h-[224px] tw:relative">
                    <LazyImage
                      src={
                        lang === "EN"
                          ? cmspage?.page_content_en.image2
                          : cmspage?.page_content_jp.image2
                      }
                      alt="Highly-trained chauffeurs"
                      wrapperClassName="tw:h-[224px] tw:w-[252px]"
                      className="tw:h-full tw:w-full tw:object-cover"
                    />
                    <div className="tw:bg-[linear-gradient(180deg,_rgba(39,_39,_39,_0.18)_70.91%,_#272727_104.19%)] tw:h-full tw:absolute tw:w-full tw:top-0 tw:z-10"></div>
                  </div>
                  <div className="tw:px-4 tw:absolute tw:top-[146px] tw:z-20">
                    <div className="tw:border-t tw:border-t-[#dbbe78]">
                      <div className="tw:my-[15px]">
                        <div
                          className="tw:!font-libre-caslon-display tw:text-white tw:!text-lg tw:!font-normal tw:!leading-[24px]"
                          dangerouslySetInnerHTML={{
                            __html:
                              lang === "EN"
                                ? cmspage?.page_content_en.content5
                                : cmspage?.page_content_jp.content5,
                          }}
                        ></div>
                      </div>
                      <div
                        className={cn(
                          "tw:!font-hanken-grotesk tw:!font-normal tw:!text-[#DCDBDB]",
                          getTypographyClass(12, undefined, { important: true })
                        )}
                        dangerouslySetInnerHTML={{
                          __html:
                            lang === "EN"
                              ? cmspage?.page_content_en.content6
                              : cmspage?.page_content_jp.content6,
                        }}
                      >
                        {/* {t("Index.Card.One.Content")} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tw:h-[330px] tw:overflow-hidden tw:relative tw:px-1">
                <div className="tw:w-[252px] tw:bg-[#272727] tw:h-full tw:rounded-[5px] tw:overflow-hidden">
                  <div className="tw:h-[224px] tw:relative">
                    <LazyImage
                      src={
                        lang === "EN"
                          ? cmspage?.page_content_en.image3
                          : cmspage?.page_content_jp.image3
                      }
                      alt="Highly-trained chauffeurs"
                      wrapperClassName="tw:h-[224px] tw:w-[252px]"
                      className="tw:h-full tw:w-full tw:object-cover"
                    />
                    <div className="tw:bg-[linear-gradient(180deg,_rgba(39,_39,_39,_0.18)_70.91%,_#272727_104.19%)] tw:h-full tw:absolute tw:w-full tw:top-0 tw:z-10"></div>
                  </div>
                  <div className="tw:px-4 tw:absolute tw:top-[146px] tw:z-20">
                    <div className="tw:border-t tw:border-t-[#dbbe78]">
                      <div className="tw:my-[15px]">
                        <div
                          className="tw:!font-libre-caslon-display tw:text-white tw:!text-lg tw:!font-normal tw:!leading-[24px]"
                          dangerouslySetInnerHTML={{
                            __html:
                              lang === "EN"
                                ? cmspage?.page_content_en.content7
                                : cmspage?.page_content_jp.content7,
                          }}
                        ></div>
                      </div>
                      <div
                        className={cn(
                          "tw:!font-hanken-grotesk tw:!font-normal tw:!text-[#DCDBDB]",
                          getTypographyClass(12, undefined, { important: true })
                        )}
                        dangerouslySetInnerHTML={{
                          __html:
                            lang === "EN"
                              ? cmspage?.page_content_en.content8
                              : cmspage?.page_content_jp.content8,
                        }}
                      >
                        {/* {t("Index.Card.One.Content")} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tw:h-[330px] tw:overflow-hidden tw:relative tw:px-1">
                <div className="tw:w-[252px] tw:bg-[#272727] tw:h-full tw:rounded-[5px] tw:overflow-hidden">
                  <div className="tw:h-[224px] tw:relative">
                    <LazyImage
                      src={
                        lang === "EN"
                          ? cmspage?.page_content_en.image4
                          : cmspage?.page_content_jp.image4
                      }
                      alt="Highly-trained chauffeurs"
                      wrapperClassName="tw:h-[224px] tw:w-[252px]"
                      className="tw:h-full tw:w-full tw:object-cover"
                    />
                    <div className="tw:bg-[linear-gradient(179.78deg,_rgba(39,_39,_39,_0.05)_70.91%,_#272727_99.81%)] tw:h-full tw:absolute tw:w-full tw:top-0 tw:z-10"></div>
                  </div>
                  <div className="tw:px-4 tw:absolute tw:top-[146px] tw:z-20">
                    <div className="tw:border-t tw:border-t-[#dbbe78]">
                      <div className="tw:my-[15px]">
                        <div
                          className="tw:!font-libre-caslon-display tw:text-white tw:!text-lg tw:!font-normal tw:!leading-[24px]"
                          dangerouslySetInnerHTML={{
                            __html:
                              lang === "EN"
                                ? cmspage?.page_content_en.content9
                                : cmspage?.page_content_jp.content9,
                          }}
                        ></div>
                      </div>
                      <div
                        className={cn(
                          "tw:!font-hanken-grotesk tw:!font-normal tw:!text-[#DCDBDB]",
                          getTypographyClass(12, undefined, { important: true })
                        )}
                        dangerouslySetInnerHTML={{
                          __html:
                            lang === "EN"
                              ? cmspage?.page_content_en.content10
                              : cmspage?.page_content_jp.content10,
                        }}
                      >
                        {/* {t("Index.Card.One.Content")} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Slider>
          </Reveal>
          {/* Desktop cards: one Stagger drives the entrance order, and each
              card's hover gesture propagates down to the image zoom. */}
          <Stagger
            className="tw:hidden tw:md:grid tw:md:grid-cols-4 tw:md:gap-x-2"
            stagger={0.1}
          >
            {[
              { image: "image1", title: "content3", body: "content4" },
              { image: "image2", title: "content5", body: "content6" },
              { image: "image3", title: "content7", body: "content8" },
              { image: "image4", title: "content9", body: "content10" },
            ].map((card) => {
              const content =
                lang === "EN"
                  ? cmspage?.page_content_en
                  : cmspage?.page_content_jp;
              return (
                <HoverCard
                  key={card.image}
                  lift={-8}
                  className="tw:md:h-[660px] tw:lg:h-[540px] tw:xl:h-[500px] tw:2xl:h-[470px] tw:rounded-[5px] tw:overflow-hidden tw:bg-[#272727] tw:relative"
                >
                  <div className="tw:w-full tw:relative">
                    <motion.div variants={imageZoom()} className="tw:w-full">
                      <LazyImage
                        src={content?.[card.image]}
                        alt="Highly-trained chauffeurs"
                        wrapperClassName="tw:w-full tw:h-[374px]"
                        className="tw:w-full tw:h-full tw:object-cover"
                      />
                    </motion.div>
                    <div className="tw:bg-[linear-gradient(179.78deg,_rgba(39,_39,_39,_0.05)_70.91%,_#272727_99.81%)] tw:h-full tw:absolute tw:w-full tw:top-0 tw:z-10"></div>
                  </div>
                  <div className="tw:px-[18px] tw:absolute tw:top-[285px] tw:z-20">
                    <div className="tw:border-t tw:border-t-[#dbbe78]">
                      <div className="tw:my-[15px]">
                        <h4
                          className="tw:!font-libre-caslon-display tw:text-white tw:!text-[22px] tw:!font-normal"
                          dangerouslySetInnerHTML={{
                            __html: content?.[card.title],
                          }}
                        ></h4>
                      </div>
                      <p
                        className={cn(
                          "tw:!font-hanken-grotesk tw:!font-normal tw:!text-[#DCDBDB]",
                          getTypographyClass(13, undefined, { important: true })
                        )}
                        dangerouslySetInnerHTML={{
                          __html: content?.[card.body],
                        }}
                      ></p>
                    </div>
                  </div>
                </HoverCard>
              );
            })}
          </Stagger>
        </div>
      </div>
      {/* <!-- section 1 end --> */}

      {/* <!-- section 2 packages--> */}
      <div className="tw:bg-[#F9F9F9] tw:py-12 tw:md:py-[72px]">
        <div className="tw:md:max-w-[1920px] tw:md:m-auto tw:md:px-[75px]">
          <div className="">
            <Reveal
              y={20}
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content11
                    : cmspage?.page_content_jp.content11,
              }}
              className="tw:text-[26px] tw:md:text-[34px] tw:font-normal tw:leading-[45px] tw:mb-0 tw:px-5 tw:md:px-0 tw:font-libre-caslon-display"
            ></Reveal>
          </div>
          <Reveal y={20} delay={0.08} className="tw:md:hidden tw:mt-8 tw:px-5">
            <Slider {...settingsSlide}>
              <div
                className="tw:h-[262px] tw:w-[242px] tw:overflow-hidden tw:px-1"
                onClick={() => history.push("./services?type=AirportTransfer")}
              >
                <div className="tw:bg-[#272727] tw:rounded-[5px]">
                  <LazyImage
                    src={
                      lang === "EN"
                        ? cmspage?.page_content_en.image5
                        : cmspage?.page_content_jp.image5
                    }
                    alt="Airport transfer service"
                    wrapperClassName="tw:h-[170px] tw:w-full"
                    className="tw:w-full tw:h-full tw:object-cover"
                  />
                  <div className="tw:p-6">
                    <div
                      className="tw:!text-white tw:!font-hanken-grotesk tw:!font-semibold tw:tracking-[3px] tw:text-[8px]"
                      dangerouslySetInnerHTML={{
                        __html:
                          lang === "EN"
                            ? cmspage?.page_content_en.content12
                            : cmspage?.page_content_jp.content12,
                      }}
                    >
                      {/* {t("Index.Card.Five.Tag")} */}
                    </div>
                    <div
                      className="tw:text-white tw:m-0 tw:mt-[6px] tw:font-libre-caslon-display tw:text-[18px]"
                      dangerouslySetInnerHTML={{
                        __html:
                          lang === "EN"
                            ? cmspage?.page_content_en.content13
                            : cmspage?.page_content_jp.content13,
                      }}
                    >
                      {/* {t("Index.Card.Five.Heading")} */}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tw:h-[262px] tw:w-[242px] tw:overflow-hidden tw:px-1"
                onClick={() => history.push("./services?type=ExecutiveTransfer")}
              >
                <div className="tw:bg-[#272727] tw:rounded-[5px]">
                  <LazyImage
                    src={
                      lang === "EN"
                        ? cmspage?.page_content_en.image7
                        : cmspage?.page_content_jp.image7
                    }
                    alt="Airport transfer service"
                    wrapperClassName="tw:h-[170px] tw:w-full"
                    className="tw:w-full tw:h-full tw:object-cover"
                  />
                  <div className="tw:p-6">
                    <div
                      className="tw:!text-white tw:!font-hanken-grotesk tw:!font-semibold tw:tracking-[3px] tw:text-[8px]"
                      dangerouslySetInnerHTML={{
                        __html:
                          lang === "EN"
                            ? cmspage?.page_content_en.content18
                            : cmspage?.page_content_jp.content18,
                      }}
                    >
                      {/* {t("Index.Card.Five.Tag")} */}
                    </div>
                    <div
                      className="tw:text-white tw:m-0 tw:mt-[6px] tw:font-libre-caslon-display tw:text-[18px]"
                      dangerouslySetInnerHTML={{
                        __html:
                          lang === "EN"
                            ? cmspage?.page_content_en.content19
                            : cmspage?.page_content_jp.content19,
                      }}
                    >
                      {/* {t("Index.Card.Five.Heading")} */}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tw:h-[262px] tw:w-[242px] tw:overflow-hidden tw:px-1"
                onClick={() => history.push("./services?type=PrivateTour")}
              >
                <div className="tw:bg-[#272727] tw:rounded-[5px]">
                  <LazyImage
                    src={
                      lang === "EN"
                        ? cmspage?.page_content_en.image8
                        : cmspage?.page_content_jp.image8
                    }
                    alt="Airport transfer service"
                    wrapperClassName="tw:h-[170px] tw:w-full"
                    className="tw:w-full tw:h-full tw:object-cover"
                  />
                  <div className="tw:p-6">
                    <div
                      className="tw:!text-white tw:!font-hanken-grotesk tw:!font-semibold tw:tracking-[3px] tw:text-[8px]"
                      dangerouslySetInnerHTML={{
                        __html:
                          lang === "EN"
                            ? cmspage?.page_content_en.content21
                            : cmspage?.page_content_jp.content21,
                      }}
                    >
                      {/* {t("Index.Card.Five.Tag")} */}
                    </div>
                    <div
                      className="tw:text-white tw:m-0 tw:mt-[6px] tw:font-libre-caslon-display tw:text-[18px]"
                      dangerouslySetInnerHTML={{
                        __html:
                          lang === "EN"
                            ? cmspage?.page_content_en.content22
                            : cmspage?.page_content_jp.content22,
                      }}
                    >
                      {/* {t("Index.Card.Five.Heading")} */}
                    </div>
                  </div>
                </div>
              </div>
            </Slider>
          </Reveal>
          <Stagger
            className="tw:hidden tw:md:grid tw:md:grid-cols-3 tw:md:gap-[10px] tw:md:mt-[34px]"
            stagger={0.1}
          >
            {[
              {
                type: "AirportTransfer",
                image: "image5",
                tag: "content12",
                title: "content13",
              },
              {
                type: "ExecutiveTransfer",
                image: "image7",
                tag: "content18",
                title: "content19",
              },
              {
                type: "PrivateTour",
                image: "image8",
                tag: "content21",
                title: "content22",
              },
            ].map((service) => {
              const content =
                lang === "EN"
                  ? cmspage?.page_content_en
                  : cmspage?.page_content_jp;
              return (
                <HoverCard
                  key={service.type}
                  lift={-8}
                  className="tw:h-[340px] tw:rounded-[5px] tw:overflow-hidden tw:bg-[#272727] tw:cursor-pointer"
                  onClick={() => history.push(`./services?type=${service.type}`)}
                >
                  <motion.div variants={imageZoom()} className="tw:w-full">
                    <LazyImage
                      src={content?.[service.image]}
                      alt="Airport transfer service"
                      wrapperClassName="tw:h-[248px] tw:w-full"
                      className="tw:w-full tw:h-full tw:object-cover"
                    />
                  </motion.div>
                  <div className="tw:p-6">
                    <div
                      className="tw:!text-white tw:!font-hanken-grotesk tw:!font-semibold tw:tracking-[3px] tw:text-[8px]"
                      dangerouslySetInnerHTML={{ __html: content?.[service.tag] }}
                    ></div>
                    <h4
                      className="tw:!text-white tw:!m-0 tw:!mt-2 tw:!font-libre-caslon-display tw:!text-[22px]"
                      dangerouslySetInnerHTML={{
                        __html: content?.[service.title],
                      }}
                    ></h4>
                  </div>
                </HoverCard>
              );
            })}
          </Stagger>
        </div>
      </div>
      {/* <!-- section 2, 2 card grid highlighted packages --> */}
      <div className="tw:md:block tw:max-w-[1920px] tw:m-auto tw:px-5 tw:md:px-[75px]">
        <div className="tw:border-b tw:border-b-[#F4F4F4] tw:pt-[32px] tw:md:py-[72px]">
          <Reveal y={20} className="tw:text-[26px] tw:md:text-[34px] tw:text-[#212529] tw:font-libre-caslon-display">
            {t("Seamless Airport Transfer Solutions")}
          </Reveal>

          <Stagger
            className="tw:mt-8 tw:grid tw:md:grid-cols-2 tw:gap-y-[14px] tw:md:gap-x-5 tw:md:mt-9"
            stagger={0.12}
          >
            {[
              {
                route: "haneda-airport&t=1",
                image: HanedaAirportImage,
                alt: "Haneda Airport",
                tag: "content24",
                title: "content25",
              },
              {
                route: "narita-airport&t=1",
                image: NaritaAirportImage,
                alt: "Haneda Airport",
                tag: "content27",
                title: "content28",
              },
            ].map((airport) => {
              const content =
                lang === "EN"
                  ? cmspage?.page_content_en
                  : cmspage?.page_content_jp;
              return (
                <HoverCard
                  key={airport.route}
                  lift={-4}
                  className="tw:h-[135px] tw:md:h-[173px] tw:cursor-pointer tw:rounded-[5px] tw:bg-white tw:flex tw:justify-between tw:hover:bg-[#FFF8E8] tw:outline-[1px] tw:outline-[#E8E8E8] tw:hover:outline-[2px] tw:hover:outline-[#DBBE78] tw:hover:border-transparent"
                  onClick={() =>
                    history.push(`/${i18n.language}/maps?type=${airport.route}`)
                  }
                >
                  <div className="tw:pl-[17px] tw:md:pl-[27px] tw:pt-9 tw:lg:pt-[46px] tw:min-w-[186px] tw:md:min-w-[160px] tw:lg:min-w-[200px] tw:xl:min-w-[270px]">
                    <AirportPinIcon
                      className="tw:w-[22px] tw:xl:w-[32px] tw:h-auto"
                      aria-label="Airport icon"
                      role="img"
                    />
                    <div
                      className="tw:!font-hanken-grotesk tw:!font-semibold tw:!text-[8px] tw:mt-[14px] tw:tracking-[3px]"
                      dangerouslySetInnerHTML={{ __html: content?.[airport.tag] }}
                    ></div>
                    <div
                      className="tw:font-libre-caslon-display tw:font-normal tw:text-[22px] tw:2xl:!text-[26px] tw:!mb-0 tw:!mt-[5px] tw:tracking-[0px]"
                      dangerouslySetInnerHTML={{
                        __html: content?.[airport.title],
                      }}
                    ></div>
                  </div>
                  <div className="tw:w-full tw:overflow-hidden">
                    <motion.img
                      variants={imageZoom(1.05)}
                      src={airport.image}
                      alt={airport.alt}
                      className="tw:h-full tw:w-full tw:object-cover"
                    />
                  </div>
                </HoverCard>
              );
            })}
          </Stagger>
        </div>
      </div>
      {/* <!-- section 2, 2 card grid end -->
    <!-- section 2 end -->

    {/* <!-- section 2, 2 card grid highlighted packages --> */}

      <div className="tw:md:block tw:max-w-[1920px] tw:m-auto tw:px-5 tw:md:px-[75px]">
        <div className="tw:border-b tw:border-b-[#F4F4F4] tw:py-[72px]">
          <Reveal y={20} className="tw:text-[26px] tw:md:text-[34px] tw:text-[#212529] tw:font-libre-caslon-display">
            {t("Smooth Shinkansen Transfer Options")}
          </Reveal>
          <Stagger
            className="tw:mt-8 tw:grid tw:md:grid-cols-2 tw:gap-y-[14px] tw:md:gap-x-5 tw:md:mt-9"
            stagger={0.12}
          >
            {[
              {
                route: "tokyo-station",
                image: TokyoStation,
                alt: "Tokyo Station",
                label: "Tokyo Station",
              },
              {
                route: "shinagawa-station",
                image: ShinagawaStation,
                alt: "Shinagawa Station",
                label: "Shinagawa Station",
              },
            ].map((station) => (
              <HoverCard
                key={station.route}
                lift={-4}
                className="tw:h-[135px] tw:md:h-[173px] tw:rounded-[5px] tw:bg-[#272727] tw:flex tw:justify-between tw:cursor-pointer tw:hover:bg-[#3a3a3a]"
                onClick={() =>
                  history.push(`/${i18n.language}/maps?type=${station.route}`)
                }
              >
                <div className="tw:pl-[17px] tw:md:pl-[27px] tw:pt-9 tw:lg:pt-[46px] tw:min-w-[186px] tw:md:min-w-[160px] tw:lg:min-w-[200px] tw:xl:min-w-[270px]">
                  <TrainPinIcon
                    className="tw:w-[22px] tw:xl:w-[32px] tw:h-auto"
                    aria-label="Train icon"
                    role="img"
                  />
                  <div className="tw:!font-hanken-grotesk tw:!font-semibold tw:!text-[8px] tw:mt-[14px] tw:tracking-[3px] tw:text-white">
                    {t("SHINKANSEN TRANSFER")}
                  </div>
                  <div className="tw:font-libre-caslon-display tw:font-normal tw:text-[22px] tw:2xl:!text-[26px] tw:!mb-0 tw:!mt-[5px] tw:tracking-[0px] tw:text-white">
                    {t(station.label)}
                  </div>
                </div>
                <div className="tw:w-full tw:overflow-hidden">
                  <motion.img
                    variants={imageZoom(1.05)}
                    src={station.image}
                    alt={station.alt}
                    className="tw:h-full tw:w-full tw:object-cover"
                  />
                </div>
              </HoverCard>
            ))}
          </Stagger>
        </div>
      </div>
      {/* <!-- section 2, 2 card grid end -->
    <!-- section 2 end -->


    <!-- section 4, vehicles --> */}
      <div className="tw:max-w-[1920px] tw:m-auto tw:px-5 tw:md:px-[75px] tw:pb-[104px] tw:md:pb-[72px]">
        <div className={`tw:pt-12 tw:md:pt-[72px] tw:pb-9 tw:flex tw:flex-col tw:md:flex-row tw:justify-between tw:md:justify-start tw:items-start tw:md:items-center tw:gap-3 tw:md:gap-4`}>
          <Reveal
            y={20}
            className="tw:text-[26px] tw:md:text-[34px] tw:text-[#212529] tw:font-libre-caslon-display tw:w-auto"
            dangerouslySetInnerHTML={{
              __html:
                lang === "EN"
                  ? cmspage?.page_content_en.content30
                  : cmspage?.page_content_jp.content30,
            }}
          >
          </Reveal>
          <motion.button
            onClick={() => setShowDisclaimerModal(true)}
            whileHover={pressable.hover}
            whileTap={pressable.tap}
          >
            <div className="tw:bg-[#F5F5F5] tw:w-auto tw:h-[32px] tw:rounded-md tw:text-[#4E4E4E] tw:flex tw:items-center tw:px-2 tw:text-base tw:font-hanken-grotesk tw:font-medium tw:justify-center tw:text-[14px] tw:gap-2">
              <DisclaimerIcon size={20} aria-label="Passengers" role="img" />
              {t("componentDisclaimer.title")}
            </div>
          </motion.button>
        </div>
        <Stagger
          className="tw:grid tw:grid-cols-1 tw:lg:grid-cols-2 tw:2xl:grid-cols-3 tw:md:[grid-auto-rows:1fr] tw:gap-x-4 tw:gap-y-4 tw:md:gap-y-[22px]"
          stagger={0.08}
          viewport={{ amount: 0.05 }}
        >
          {cmspage?.additionalContent
            ?.sort((a, b) => a.prioritize - b.prioritize)
            .map((v) => (
              <VehicleCard
                key={v.typename}
                v={v}
                onClick={() => {
                  if (getLinkDetail(v.typename) !== "-") {
                    history.push(getLinkDetail(v.typename));
                  }
                }}
              />
            ))}
        </Stagger>
      </div>
      <DisclaimerModal
        onClose={() => { setShowDisclaimerModal(false) }}
        show={showDisclaimerModal}
      />
    </FrontLayout >
  );
};

export default Index;
